import BetDrawerLogic from "app/logic/betDrawerLogic";
import { useEffect } from "react";
import { connect } from "react-redux";

// for mobile view make sure betslips panel loads with all betslip expanded by default
// as expand/collapse all betslips feature not available in mobile view
function MobileDefaultBetSlipPanelSettings(props: {
  setMobileDefaultCollapseAllBets: Function;
}) {
  // on component did mount set default layout
  useEffect(() => {
    // set collapseAllBetSlips to false in store
    props.setMobileDefaultCollapseAllBets();
    // update betslipList active parameters to default layout with all betslip expanded by default
    BetDrawerLogic.expandAllBetSlips();
  }, []);

  return <></>;
}

function mapDispatchToProps(dispatch) {
  return {
    setMobileDefaultCollapseAllBets: () =>
      dispatch.betSlipListModel.setMobileDefaultCollapseAllBets(),
  };
}

export default connect(
  null,
  mapDispatchToProps
)(MobileDefaultBetSlipPanelSettings) as any;
